import { useCallback, useState } from "react";
import Navbar from "./components/nav/Navbar";
import Hero from "./components/header/Hero";
import About from "./components/about/About";
import Portfolio from "./components/portfolio/Portfolio";
import Experience from "./components/experience/Experience";
import Skills from "./components/services/Skills";
import Background from "./components/background/Background";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Preloader from "./components/motion/Preloader";
import SmoothScroll from "./components/motion/SmoothScroll";
import Cursor from "./components/motion/Cursor";
import Starfield from "./components/motion/Starfield";

function App() {
  const [ready, setReady] = useState(false);
  const onReady = useCallback(() => setReady(true), []);

  return (
    <>
      <Preloader onDone={onReady} />
      <Starfield ready={ready} />
      <SmoothScroll ready={ready} />
      <Cursor ready={ready} />
      <Navbar />
      <main>
        <Hero ready={ready} />
        <About />
        <Portfolio />
        <Experience />
        <Skills />
        <Background />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
